
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import SuperAdminActions from 'store/redux/superadmin'
import GlobalActions from 'store/redux/global'
import { Text, Button } from 'components'
import JSONEditor from 'jsoneditor'
import 'jsoneditor/dist/jsoneditor.css'
import { pageData } from 'decorators'
import { translate } from 'react-i18next'
import FLAG from 'utils/flags'
// import DATA_CONFIG_FILE from 'data/mocks/superadmin/config.json'
import AdminTemplate from '../../templates/AdminTemplate'
import './ConfigFile.css'

@connect(
    state => ({
        configFileData: state.superadmin.configFile,
        isUpdating: state.global.flag[FLAG.SUPERADMIN_UPDATING_CONFIG_FILE] === FLAG.LOADING,
        isAuthenticated: state.auth.isAuthenticated,
        reconnecting: state.auth.reconnecting,
    }),
    {
        requestConfigFileData: SuperAdminActions.requestConfigFileData,
        requestUpdateConfigFile: SuperAdminActions.requestUpdateConfigFile,
        modalRequest: GlobalActions.request,
        error: GlobalActions.error
    }
)
@pageData({ title: 'SuperAdmin ConfigFile' })
@translate()
export class SuperAdminConfigFile extends PureComponent {
    componentWillMount() {
        const { isAuthenticated, reconnecting, requestConfigFileData } = this.props
        if (isAuthenticated && !reconnecting) {
            requestConfigFileData()
        }
    }
    componentDidMount() {
        // this.setConfigFileData(DATA_CONFIG_FILE)
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.reconnecting && !nextProps.reconnecting) {
            this.props.requestConfigFileData()
        }
        if (nextProps.configFileData !== this.props.configFileData) {
            if (nextProps.configFileData.default !== this.props.configFileData.default) {
                this.setConfigFileData(nextProps.configFileData)
            } else {
                this.setCurrentFile(nextProps.configFileData.current)
            }
        }
    }

    setCurrentEditorRef = ref => {
        this.currentEditorRef = ref
    }
    setDefaultEditorRef = ref => {
        this.defaultEditorRef = ref
    }

    setConfigFileData = ({ current, default: template, schema }) => {
        if (!this.currentEditor) {
            this.currentEditor = new JSONEditor(this.currentEditorRef, {
                mode: 'form'
            })
        }
        this.setCurrentFile(current)
        this.currentEditor.setSchema(schema.main, schema.refs)
        if (!this.defaultEditor) {
            this.defaultEditor = new JSONEditor(this.defaultEditorRef, {
                mode: 'view'
            })
        }
        this.defaultEditor.set(template)
        this.defaultEditor.expandAll()
    }
    setCurrentFile = json => {
        this.currentEditor.set(json)
        this.currentEditor.expandAll()
    }

    updateConfigFile = () => {
        const { requestUpdateConfigFile, modalRequest, error, t } = this.props
        if ((this.currentEditor.errorNodes || []).length > 0) {
            error({
                title: t('superadmin.config.validationError.title'),
                text: t('superadmin.config.validationError.text')
            })
        } else {
            modalRequest({
                title: t('superadmin.config.updateConfirmation.title'),
                text: t('superadmin.config.updateConfirmation.text'),
                actionBtns: [
                    { text: t('superadmin.config.updateConfirmation.doneBtn'), action: () => requestUpdateConfigFile(this.currentEditor.get()) },
                    { text: t('superadmin.config.updateConfirmation.cancelBtn') }
                ]
            })
        }
    }
    restoreConfigFile = () => {
        const { modalRequest, t } = this.props
        modalRequest({
            title: t('superadmin.config.restoreConfirmation.title'),
            text: t('superadmin.config.restoreConfirmation.text'),
            actionBtns: [
                { text: t('superadmin.config.restoreConfirmation.doneBtn'), action: () => this.setCurrentFile(this.defaultEditor.get()) },
                { text: t('superadmin.config.restoreConfirmation.cancelBtn') }
            ]
        })
    }

    render() {
        const { isUpdating, t } = this.props
        return (
            <AdminTemplate className="SuperAdminConfigFile px-5 pb-5" backRoute="/admin">
                <h1 className="text-center">{t('superadmin.config.title')}</h1>
                <Text>{t('superadmin.config.intro')}</Text>

                <div className="flex-grow flex-self-stretch flex row-stretch">
                    <div className="config-file-wrapper flex-grow">
                        <h2>{t('superadmin.config.currentFile')}</h2>
                        <div ref={this.setCurrentEditorRef} id="current-jsoneditor" className="jsoneditor-wrapper" />
                    </div>
                    <div className="Actions flex-self-center px-3">
                        <Button tag="a" color="primary" loading={isUpdating} onClick={this.updateConfigFile}>
                            {t('superadmin.config.updateBtn')}
                        </Button>
                        <Button tag="a" color="primary" outline onClick={this.restoreConfigFile}>
                            &larr; {t('superadmin.config.restoreBtn')}
                        </Button>
                    </div>
                    <div className="config-file-wrapper flex-grow">
                        <h2>{t('superadmin.config.defaultFile')}</h2>
                        <div ref={this.setDefaultEditorRef} id="default-jsoneditor" className="jsoneditor-wrapper" />
                    </div>
                </div>
            </AdminTemplate>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/SuperAdmin/ConfigFile/SuperAdminConfigFile.js